// Dynamic data translation utility
// This handles translation of API response data and dynamic content

// Temple name translations
const TEMPLE_TRANSLATIONS = {
  'Kashi Vishwanath': 'काशी विश्वनाथ',
  'Jagannath Puri': 'जगन्नाथ पुरी',
  'Vaishno Devi': 'वैष्णो देवी',
  'Har Ki Pauri': 'हर की पौड़ी',
  'Lokhnath Temple': 'लोकनाथ मंदिर',
  'Kamakhya Temple': 'कामाख्या मंदिर',
  'Tirupati Balaji': 'तिरुपति बालाजी',
  'Golden Temple': 'स्वर्ण मंदिर',
  'Somnath Temple': 'सोमनाथ मंदिर',
  'Meenakshi Temple': 'मीनाक्षी मंदिर',
  'Kashi Vishwanath Temple': 'काशी विश्वनाथ मंदिर',
  'Jagannath Puri Temple': 'जगन्नाथ पुरी मंदिर',
  'Jagannath Temple': 'जगन्नाथ मंदिर',
  'Vaishno Devi Temple': 'वैष्णो देवी मंदिर',
  'Har Ki Pauri Ghat': 'हर की पौड़ी घाट',
  'Lokhnath Mandir': 'लोकनाथ मंदिर',
  'Kamakhya Mandir': 'कामाख्या मंदिर',
  'Tirupati Balaji Temple': 'तिरुपति बालाजी मंदिर',
  'Tirupati Temple': 'तिरुपति मंदिर',
  'Golden Temple Amritsar': 'स्वर्ण मंदिर अमृतसर',
  'Somnath Mandir': 'सोमनाथ मंदिर',
  'Meenakshi Amman Temple': 'मीनाक्षी अम्मन मंदिर',
  'Ucchait Bhagwati Temple': 'उच्चैठ भगवती मंदिर'
};

// Location translations
const LOCATION_TRANSLATIONS = {
  'Varanasi, Uttar Pradesh': 'वाराणसी, उत्तर प्रदेश',
  'Puri, Odisha': 'पुरी, ओडिशा',
  'Katra, Jammu & Kashmir': 'कटरा, जम्मू और कश्मीर',
  'Haridwar, Uttarakhand': 'हरिद्वार, उत्तराखंड',
  'Guwahati, Assam': 'गुवाहाटी, असम',
  'Tirupati, Andhra Pradesh': 'तिरुपति, आंध्र प्रदेश',
  'Amritsar, Punjab': 'अमृतसर, पंजाब',
  'Somnath, Gujarat': 'सोमनाथ, गुजरात',
  'Madurai, Tamil Nadu': 'मदुरै, तमिलनाडु',
  'Varanasi, UP': 'वाराणसी, उत्तर प्रदेश',
  'Katra, J&K': 'कटरा, जम्मू और कश्मीर',
  'Haridwar, UK': 'हरिद्वार, उत्तराखंड',
  'Tirupati, AP': 'तिरुपति, आंध्र प्रदेश',
  'Madurai, TN': 'मदुरै, तमिलनाडु',
  'Sitamarhi, Bihar': 'सीतामढ़ी, बिहार',
  'Gujarat': 'गुजरात'
};

// Deity translations
const DEITY_TRANSLATIONS = {
  'Lord Shiva': 'भगवान शिव',
  'Lord Jagannath': 'भगवान जगन्नाथ',
  'Goddess Vaishno Devi': 'देवी वैष्णो देवी',
  'Goddess Kamakhya': 'देवी कामाख्या',
  'Lord Venkateswara': 'भगवान वेंकटेश्वर',
  'Guru Nanak Dev': 'गुरु नानक देव',
  'Goddess Meenakshi': 'देवी मीनाक्षी',
  'Lord Somnath': 'भगवान सोमनाथ',
  'Sikh Shrine': 'सिख तीर्थस्थल',
  'Goddess Durga': 'देवी दुर्गा'
};

// Common temple-related terms
const TEMPLE_TERMS_TRANSLATIONS = {
  'Temple': 'मंदिर',
  'Mandir': 'मंदिर',
  'Ghat': 'घाट',
  'Shrine': 'मंदिर',
  'Sanctuary': 'मंदिर',
  'Sacred': 'पवित्र',
  'Holy': 'पवित्र',
  'Divine': 'दिव्य',
  'Spiritual': 'आध्यात्मिक',
  'Blessings': 'आशीर्वाद',
  'Prayers': 'प्रार्थना',
  'Aarti': 'आरती',
  'Darshan': 'दर्शन',
  'Pilgrimage': 'तीर्थयात्रा',
  'Devotees': 'भक्त',
  'Worship': 'पूजा',
  'Ceremony': 'समारोह',
  'Ritual': 'अनुष्ठान',
  'Festival': 'त्योहार',
  'Celebration': 'उत्सव',
  'Architecture': 'वास्तुकला',
  'History': 'इतिहास',
  'Significance': 'महत्व',
  'Offerings': 'भेंट',
  'Timings': 'समय',
  'Visitors': 'दर्शक',
  'Daily': 'दैनिक',
  'Visit': 'दौरा',
  'Explore': 'अन्वेषण',
  'Discover': 'खोज',
  'Heritage': 'विरासत',
  'Culture': 'संस्कृति',
  'Tradition': 'परंपरा',
  'Ancient': 'प्राचीन',
  'Historic': 'ऐतिहासिक',
  'Famous': 'प्रसिद्ध',
  'Popular': 'लोकप्रिय',
  'Important': 'महत्वपूर्ण',
  'Major': 'प्रमुख',
  'Famous for': 'के लिए प्रसिद्ध',
  'Known for': 'के लिए जाना जाता',
  'Located in': 'में स्थित',
  'Dedicated to': 'समर्पित',
  'Open': 'खुला',
  'Closed': 'बंद',
  'All Year Round': 'साल भर',
  'Coming Soon': 'जल्द आ रहा है',
  'Live': 'लाइव',
  'Watch Live': 'लाइव देखें',
  'Book Puja': 'पूजा बुक करें',
  'Back to Temples': 'मंदिरों पर वापस जाएं',
  'You May Also Like': 'आपको यह भी पसंद आ सकता है',
  'Location Map': 'स्थान का नक्शा',
  'About the Temple': 'मंदिर के बारे में',
  'Temple Details': 'मंदिर का विवरण',
  'Travel Details': 'यात्रा का विवरण',
  'Social Media': 'सोशल मीडिया',
  'Airplane': 'हवाई जहाज',
  'Train': 'ट्रेन',
  'Road': 'सड़क',
  'By Air': 'हवाई मार्ग से',
  'By Train': 'ट्रेन से',
  'By Road': 'सड़क मार्ग से'
};

// Live stream related terms
const LIVE_STREAM_TRANSLATIONS = {
  'Live': 'लाइव',
  'Streaming': 'स्ट्रीमिंग',
  'Broadcasting': 'प्रसारण',
  'Online': 'ऑनलाइन',
  'Real-time': 'वास्तविक समय',
  'Watching': 'देख रहे हैं',
  'Viewers': 'दर्शक',
  'Audience': 'दर्शक',
  'Join': 'शामिल हों',
  'Participate': 'भाग लें',
  'Experience': 'अनुभव',
  'Connect': 'जुड़ें',
  'Prayer': 'प्रार्थना',
  'Meditation': 'ध्यान',
  'Chanting': 'जप',
  'Bhajan': 'भजन',
  'Kirtan': 'कीर्तन',
  'Satsang': 'सत्संग'
};

// Function to translate temple names
export const translateTempleName = (name, language = 'hi') => {
  if (language === 'en') return name;
  if (!name || typeof name !== 'string') return name;
  
  return TEMPLE_TRANSLATIONS[name] || name;
};

// Function to translate locations
export const translateLocation = (location, language = 'hi') => {
  if (language === 'en') return location;
  if (!location || typeof location !== 'string') return location;
  
  return LOCATION_TRANSLATIONS[location] || location;
};

// Function to translate deity names
export const translateDeity = (deity, language = 'hi') => {
  if (language === 'en') return deity;
  if (!deity || typeof deity !== 'string') return deity;
  
  return DEITY_TRANSLATIONS[deity] || deity;
};

// Function to translate live stream titles
export const translateLiveStreamTitle = (title, language = 'hi') => {
  if (language === 'en') return title;
  if (!title || typeof title !== 'string') return title;
  
  let translatedTitle = title;
  
  // Replace temple names
  Object.entries(TEMPLE_TRANSLATIONS).forEach(([english, hindi]) => {
    translatedTitle = translatedTitle.replace(new RegExp(english, 'gi'), hindi);
  });
  
  // Replace common terms
  Object.entries(LIVE_STREAM_TRANSLATIONS).forEach(([english, hindi]) => {
    translatedTitle = translatedTitle.replace(new RegExp(`\\b${english}\\b`, 'gi'), hindi);
  });
  
  return translatedTitle;
};

// Function to translate live stream descriptions
export const translateLiveStreamDescription = (description, language = 'hi') => {
  if (language === 'en') return description;
  if (!description || typeof description !== 'string') return description;
  
  let translatedDescription = description;
  
  // Replace temple terms
  Object.entries(TEMPLE_TERMS_TRANSLATIONS).forEach(([english, hindi]) => {
    translatedDescription = translatedDescription.replace(new RegExp(`\\b${english}\\b`, 'gi'), hindi);
  });
  
  // Replace live stream terms
  Object.entries(LIVE_STREAM_TRANSLATIONS).forEach(([english, hindi]) => {
    translatedDescription = translatedDescription.replace(new RegExp(`\\b${english}\\b`, 'gi'), hindi);
  });
  
  return translatedDescription;
};

// Function to translate temple data object
export const translateTempleData = (templeData, language = 'hi') => {
  if (language === 'en') return templeData;
  if (!templeData || typeof templeData !== 'object') return templeData;
  
  return {
    ...templeData,
    name: translateTempleName(templeData.name, language),
    location: translateLocation(templeData.location, language),
    deity: translateDeity(templeData.deity, language),
    description: translateLiveStreamDescription(templeData.description, language)
  };
};

// Function to translate live stream data object
export const translateLiveStreamData = (streamData, language = 'hi') => {
  if (language === 'en') return streamData;
  if (!streamData || typeof streamData !== 'object') return streamData;
  
  return {
    ...streamData,
    title: translateLiveStreamTitle(streamData.title, language),
    description: translateLiveStreamDescription(streamData.description, language),
    channelTitle: translateTempleName(streamData.channelTitle, language)
  };
};

// Function to translate any dynamic content
export const translateDynamicContent = (content, language = 'hi') => {
  if (language === 'en') return content;
  if (content === null || content === undefined) return content;
  
  if (typeof content === 'string') {
    let translated = content;
    
    // Apply all translation mappings
    const allTranslations = {
      ...TEMPLE_TRANSLATIONS,
      ...LOCATION_TRANSLATIONS,
      ...DEITY_TRANSLATIONS,
      ...TEMPLE_TERMS_TRANSLATIONS,
      ...LIVE_STREAM_TRANSLATIONS
    };
    
    Object.entries(allTranslations).forEach(([english, hindi]) => {
      translated = translated.replace(new RegExp(`\\b${english}\\b`, 'gi'), hindi);
    });
    
    return translated;
  }
  
  if (typeof content === 'object' && content !== null) {
    const translated = {};
    Object.keys(content).forEach(key => {
      translated[key] = translateDynamicContent(content[key], language);
    });
    return translated;
  }
  
  return content;
};

// Hook for using dynamic translations
export const useDynamicTranslation = (language = 'hi') => {
  return {
    translateTempleName: (name) => translateTempleName(name, language),
    translateLocation: (location) => translateLocation(location, language),
    translateDeity: (deity) => translateDeity(deity, language),
    translateLiveStreamTitle: (title) => translateLiveStreamTitle(title, language),
    translateLiveStreamDescription: (description) => translateLiveStreamDescription(description, language),
    translateTempleData: (templeData) => translateTempleData(templeData, language),
    translateLiveStreamData: (streamData) => translateLiveStreamData(streamData, language),
    translateDynamicContent: (content) => translateDynamicContent(content, language)
  };
};
